import escudo from "../../../assets/sport.png"; 
import React, { useEffect, useState } from "react";
import "../Styles/EstadisticasTorneo.css";
import { ClipLoader } from "react-spinners";
import { useParams } from "react-router-dom";
import { BASE_URL } from "./../../../config";
import axios from "axios";
import AmonestacionesComponent from "./AmonestacionesComponent";
import GoleadoresComponent from "./GoleadoresComponent"; 

const EstadisticasTorneo = () => {
  const [cargando, setCargando] = useState(true);
  const [grupos, setGrupos] = useState([]);
  const [goleadores, setGoleadores] = useState([]); 
  const { id, nombre } = useParams();
  const nombreTorneo = decodeURIComponent(nombre);

  useEffect(() => {
    const fetchGrupos = async () => {
      try {
        const response = await axios.get(`${BASE_URL}torneos/${id}/grupos`);
        setGrupos(response.data);
      } catch (error) {
        console.error("Error al obtener los datos de los grupos:", error);
      } finally {
        setCargando(false);
      }
    };

    const fetchGoleadores = async () => {
      try {
        const response = await axios.get(`${BASE_URL}goleadores/${id}`);
        setGoleadores(response.data);
      } catch (error) {
        console.error("Error al obtener los datos de los goleadores:", error);
      }
    };

    fetchGrupos();
    fetchGoleadores();
  }, [id]);

  return (
    <div className="estadisticas-torneo-container">
      <h2>Estadísticas del Torneo: {nombreTorneo || "Cargando..."}</h2>
      {cargando ? (
        <div className="cargando">
          <ClipLoader color="#00BFFF" loading={cargando} size={50} />
        </div>
      ) : (
        <>
          {grupos.length > 0 ? (
            <div className="grupos-grid">
              {grupos.map((grupo) => (
                <div key={grupo.id} className="grupo-card">
                  <h3>{grupo.nombreGrupo}</h3>
                  <table className="estadisticas-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Logo</th>
                        <th>Nombre</th>
                        <th>PJ</th>
                        <th>PG</th>
                        <th>GF</th>
                        <th>GC</th>
                        <th>DG</th>
                        <th>Puntos</th>
                      </tr>
                    </thead>
                    <tbody>
                      {grupo.equipos
                        .sort((a, b) => b.puntos - a.puntos)
                        .map((equipo, index) => (
                          <tr key={equipo.id}>
                            <td>{index + 1}</td>
                            <td>
                              <img
                                src={equipo.logoUrl || escudo}
                                alt={`${equipo.nombre} Logo`}
                                className="equipo-logo"
                              />
                            </td>
                            <td>{equipo.nombre}</td>
                            <td>{equipo.partidosJugados || 0}</td>
                            <td>{equipo.partidosGanados || 0}</td>
                            <td>{equipo.golesFavor || 0}</td>
                            <td>{equipo.golesContra || 0}</td>
                            <td>{equipo.diferenciaGoles || 0}</td>
                            <td>{equipo.puntos || 0}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-datos">
              <p>No se encontraron datos para este torneo.</p>
            </div>
          )}

          <GoleadoresComponent goleadores={goleadores} /> 
          <AmonestacionesComponent />
        </>
      )}
    </div>
  );
};

export default EstadisticasTorneo;
